import React, { Component } from 'react'
import Grid from '@material-ui/core/Grid';
import styled from 'styled-components';

const MethodsContainer = styled.div`
    color:white;
    width:100vw;
    box-sizing:border-box;
    padding:40px 20%;
    div.MuiGrid-root {
        font-family:"Open Sans", sans-serif;
        color:white;
        font-size:20px;
        line-height:2;
    }
`

class Methods extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }; 
    }


    render() {
        return (
            <MethodsContainer>
                <Grid container spacing={3}>
                    <Grid item xs={12} lg={6}>
                        Urban tree networks are essential for the ecological resilience and character of cities. Street trees, specifically, are an important part of the urban forest, softening the harsh building-street interface and filtering the air between pedestrians and traffic. We use tree inventory data to measure street tree diversity in eight global cities, comparing the city center with the outer areas of the city. 
                    </Grid>
                    <Grid item xs={12} lg={6}>
                    We measure street tree networks against the 10/20/30 rule, which suggests an urban forest should be no more than 10% of one species, 20% of one genus, and 30% of one family. We also use diversity indices — the Shannon Index and Simpson Index — to account for the abundance and evenness of the species present in the city.    
                    </Grid>
                    <Grid item xs={12} style={{textAlign:"center"}}>
                        <br/>
                        <p className="tooltip">Learn which tree species, genus and family are predominant in each city, and explore tree diversity on the maps below, block by block, tree by tree.</p>
                    </Grid>
                </Grid>
           </MethodsContainer>
        );
    }
}

export default Methods;
